import { useTranslationWrapper } from '@utils/useTranslationWrapper';
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import CustomTypography from '@components/common/CustomTypography';
import publishSuccess from '@assets/images/publish-success.svg';
import erroImage from '@assets/images/profile-error-illustration.svg';

const Wrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center'
}));

const DocusignCallback = () => {
  const { t } = useTranslationWrapper();
  const [showSigningComplete, setShowSigningComplete] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const event = urlParams.get('event');

    // Notify the parent window that signing is complete
    if (event === 'signing_complete') {
      setShowSigningComplete(true);
      window.parent.postMessage({ type: 'DOCUSIGN_SIGNING_COMPLETE' }, '*');
    } else if (event === 'decline') {
      window.parent.postMessage({ type: 'DOCUSIGN_SIGNING_DECLINED' }, '*');
    } else {
      // do nothing
    }
  }, []);

  return (
    <Wrapper>
      <img src={showSigningComplete ? publishSuccess : erroImage} alt='signing_alt' className='p-20p' />
      <CustomTypography size='20' weight='semibold'>
        {t(showSigningComplete ? 'SIGNING_COMPLETE' : 'SIGNING_INCOMPLETE')}
      </CustomTypography>
      <CustomTypography>{t('YOU_MAY_CLOSE_THIS_WINDOW')}</CustomTypography>
    </Wrapper>
  );
};

export default DocusignCallback;
